import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Inairhandlewarning from '../entities/inairhandlewarning'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface InairhandlewarningState extends ListState<Inairhandlewarning>{
    editHandlewarnings:Inairhandlewarning
    anlyseHandlewarning:Inairhandlewarning
    seeHandlewarnings:Inairhandlewarning
}
class InairhandlewarningModule extends ListModule<InairhandlewarningState,any,Inairhandlewarning>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Inairhandlewarning>(),
        loading:false        
    }
    actions={
        async getPage(context:ActionContext<InairhandlewarningState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/InairHandleWarning/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Inairhandlewarning>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getPagedLast(context: ActionContext<InairhandlewarningState, any>, payload: any) {

            // context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/InairHandleWarning/GetPagedLast', { params: payload.data });
            // context.state.loading = false;
            let page = reponse.data.result as PageResult<Inairhandlewarning>;
            //context.state.totalCount = page.totalCount;
            //context.state.list = page.items;
            return page.items;
        },
        async create(context:ActionContext<InairhandlewarningState,any>,payload:any){
            await Ajax.post('/api/services/app/InairHandleWarning/CreateOrUpdate',payload.data);
        },
        async uploadimg(context:ActionContext<InairhandlewarningState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<InairhandlewarningState,any>,payload:any){
            await Ajax.put('/api/services/app/InairHandleWarning/Update',payload.data);
        },
        async delete(context:ActionContext<InairhandlewarningState,any>,payload:any){
            await Ajax.delete('/api/services/app/InairHandleWarning/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<InairhandlewarningState,any>,payload:any){
            let reponse=await Ajax.get('​/api​/services​/app​/ThHandleWarning​/GetById?Id='+payload.id);
            return reponse.data.result as Inairhandlewarning;
        },
        async getPageByDate(context: ActionContext<InairhandlewarningState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/InairHandleWarning/GetPageByDate', { params: payload.data });
            let page = reponse.data.result as PageResult<Inairhandlewarning>;
            //context.state.totalCount = page.totalCount;
            //context.state.list = page.items; 6aba6214f15918e1bc4225e3ea66df430b9fbce7
            return page.items;
        },
    };
    mutations={
        setCurrentPage(state:InairhandlewarningState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:InairhandlewarningState,pagesize:number){
            state.pageSize=pagesize;
        },
        analyse(state: InairhandlewarningState, handlewarning:Inairhandlewarning) {
            state.anlyseHandlewarning = handlewarning;
        },
        edit(state:InairhandlewarningState,handlewarning:Inairhandlewarning){
            
            state.editHandlewarnings=handlewarning;
            //console.log(state.editFloor);
        },
        see(state:InairhandlewarningState,handlewarning:Inairhandlewarning){
            
            state.seeHandlewarnings=handlewarning;
            //console.log(state.editFloor);
        }
    }
}
const inairhandlewarningModule=new InairhandlewarningModule();
export default inairhandlewarningModule;